<template>
	<div class="location-autocomplete">
		<TextInput ref="textInput" v-bind="$attrs" :is-hidden-label="isHiddenLabel" @input="updateValue">
			<template slot="tip">
				<div v-if="locationTip && locations[locationTip]" class="text-secondary">
					{{ locations[locationTip] }}
				</div>
			</template>
		</TextInput>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { TextInput } from '~/components/interface'
import { GoogleApi } from '~/assets/util/helpers/location'

/* eslint-disable camelcase */
export default {
	name: 'LocationsAutocomplete',
	components: { TextInput },
	props: {
		// if using sync emits there all values of location types
		locations: {
			type: Object,
			required: false,
			default: () => {
			}
		},
		locationType: {
			type: String,
			default: 'line1',
			validator: value => ['line1', 'postal_code', 'country', 'state', 'city'].includes(value)
		},
		locationTip: {
			type: String,
			required: false,
			default: null, // Could be one of location types
			validator: value => ['line1', 'postal_code', 'country', 'state', 'city'].includes(value)
		},
		// country code to restrict search by it
		restrictBy: {
			type: String,
			default: '',
			required: false
		},
		isHiddenLabel: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			innerInput: null,
			locationApi: null,
			lastValidValue: ''
		}
	},
	computed: {
		...mapGetters({ location: 'user/origin' })
	},
	watch: {
		restrictBy (val) {
			this.locationApi && this.locationApi.updateCountryOption(val)
		}
	},
	mounted () {
		this.$nextTick(() => {
			this.innerInput = this.$refs.textInput.$refs.input

			this.locationApi = new GoogleApi(
				this.innerInput,
				this.onSelectPlace.bind(this),
				this.restrictBy || this.location.code
			)
		})
	},
	methods: {
		onSelectPlace (data) {
			const locations = data.placeData
			const geoLocation = data.geoLocation

			if (locations && locations[this.locationType]) {
				this.lastValidValue = locations[this.locationType]
				this.$emit('update:locations', locations)
				if (geoLocation) {
					this.$emit('update:geoLocation', geoLocation)
				}
				this.updateValue(locations[this.locationType], false)
			} else {
				// not clear country
				this.$emit('update:locations', { country: this.locations.country })
				this.updateValue('')
			}
		},

		updateValue (value, checkDiff = true) {
			if (checkDiff && this.lastValidValue !== value) {
				this.$emit('update:locations', {
					[this.locationType]: value,
					country: this.locations.country
				})
			}

			this.$emit('input', value)
		}
	}
}
</script>
